export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-slate-50" data-testid="app-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6 flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="Classroom to Corporate" className="h-7 w-7 object-contain" />
          <span className="font-heading text-sm font-extrabold text-slate-800">
            Classroom to <span className="text-amber-600">Corporate</span>
          </span>
        </div>
        <p className="text-center text-xs text-slate-500 sm:text-right" data-testid="footer-credit">
          © {year} · Prepared by &amp; all rights reserved to <span className="font-semibold text-slate-700">Darshan Thakkar</span>
        </p>
      </div>
    </footer>
  );
}
